import { gameLeave } from '@/api/game'
import { showNotice, showConfirm } from '@/utils/tool'
import store from 'vuex-store/index'
import i18n from '@/i18n'

// type = game or provider
export function gameStart(type, gameOrProvider, selectedCurrency) {
  if (!store.getters.token) {
    // 未登入
    store.commit('SET_LOGIN_OPEN', true)
  } else if (type === 'game' && gameOrProvider.status === 2) {
    // 遊戲維護中
    showNotice(i18n.t('Bao.game_maintenance'))
  } else {
    // 檢查用戶是否開啟自動上分
    if (store.getters.memberInfo.auto_to_game !== 1) {
      const gameProviderId = type === 'provider' ? gameOrProvider.id : gameOrProvider.game_provider_id
      // 彈出確認視窗
      showConfirm(i18n.t('Bao.please_select_game_method'), i18n.t('Bao.to_game_directly'), i18n.t('Bao.to_game_transfer'), function() {
        if (selectedCurrency) {
          store.dispatch('launchGame', { type, gameOrProvider, selectedCurrency })
        } else {
          store.dispatch('launchGame', { type, gameOrProvider })
        }
      }, function() {
        showGameWalletModal(gameProviderId, 'in', () => {
          if (selectedCurrency) {
            store.dispatch('launchGame', { type, gameOrProvider, selectedCurrency })
          } else {
            store.dispatch('launchGame', { type, gameOrProvider })
          }
        })
      })
    } else {
      // 實際進入遊戲
      if (selectedCurrency) {
        store.dispatch('launchGame', { type, gameOrProvider, selectedCurrency })
      } else {
        store.dispatch('launchGame', { type, gameOrProvider })
      }
    }
  }
}

export function gameEnd(game_id) {
  if (!store.getters.token) {
    return
  }
  // loading開始
  store.commit('SET_LOADING', true)

  store.commit('SET_IN_GAME_ID', null)
  if (game_id) {
    showNotice('closeModal')

    gameLeave(game_id).then(response => {
      // 寫入遊戲餘額
      const current = store.getters.gameBalance
      const gameBalance = response.data.data
      current[gameBalance.game_provider_id] = gameBalance
      store.commit('SET_GAME_BALANCE_INFO', current)

      // loading結束
      store.commit('SET_LOADING', false)
      store.commit('SET_CURRENT_GAME', {})
    })
  } else {
    store.commit('SET_LOADING', false)
    store.commit('SET_CURRENT_GAME', {})
  }
}

export function showGameWalletModal(gameProviderId, fixType, callback) {
  const data = {
    gameProviderId: gameProviderId,
    fixType: fixType === undefined ? false : fixType,
    callback: callback
  }

  store.commit('SET_GAME_WALLET_MODAL', data)
}

export function hideGameWalletModal() {
  store.commit('SET_GAME_WALLET_MODAL', false)
}

// 開遊戲的時候要多帶參數 wallet_type、currency_in_game
export async function launchGameWithProviderInfo(game, selectedCurrency = null) {
  const gameProviders = store.state.game.gameProvider

  if (gameProviders) {
    const provider = gameProviders.find(
      (p) => p.id === game.game_provider_id
    )
    if (provider) {
      game.wallet_type = provider.support_wallet_type
      game.currency_in_game = provider.support_currency
      // Set the current game and pending game data, but don't launch yet
      store.commit('SET_CURRENT_GAME', game)
      store.commit('SET_PENDING_GAME_DATA', {
        type: 'game',
        gameOrProvider: game
      })
    }
  }

  // If a currency is provided, launch immediately
  if (selectedCurrency) {
    await continueGameLaunchWithCurrency(selectedCurrency)
  } else {
    // If no currency provided, check if we should show currency selection modal
    const currentGame = store.state.app.currentGame
    if (currentGame && Object.keys(currentGame).length > 0) {
      // Set pending game data for currency selection modal
      store.commit('SET_PENDING_GAME_DATA', {
        type: 'game',
        gameOrProvider: currentGame
      })
    }
  }
  // Otherwise, don't launch the game immediately, wait for currency selection in the modal
  // The continueGameLaunchWithCurrency function will be called after selection
}

// New function to continue game launch after currency selection
export async function continueGameLaunchWithCurrency(selectedCurrency) {
  store.commit('SET_CURRENCY_CHANGE_IN_PROGRESS', true)

  try {
    const pendingGame = store.state.app.pendingGameData
    const currentGame = store.state.app.currentGame
    const gameUrl = store.state.app.gameUrl

    if (pendingGame) {
      await gameStart(pendingGame.type, pendingGame.gameOrProvider, selectedCurrency)
    } else if (currentGame && Object.keys(currentGame).length > 0 && gameUrl) {
      // Clear the current game URL to trigger game end and component unmounting
      store.commit('SET_GAME_URL', '')
      // Wait a bit for the game to end properly and component to unmount
      await new Promise(resolve => setTimeout(resolve, 800))
      // Relaunch the game with the new currency
      await gameStart('game', currentGame, selectedCurrency)
    }
  } catch (error) {
    console.error('Error during currency change:', error)
    throw error
  } finally {
    // Always reset the currency change progress state
    store.commit('SET_CURRENCY_CHANGE_IN_PROGRESS', false)
  }
}
